import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;
const headerHeight = 56;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, #f7fbff 0%, #eef4fb 45%, #e8f0fa 100%)",
    color: "#1f2a44",
  },
  toolbar: {
    minHeight: headerHeight,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    backgroundColor: "#6ACFF6",
    color: "#ffffff",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    "&.MuiToolbar-root": {
      minHeight: headerHeight,
    },
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: headerHeight,
    padding: "0 12px",
    borderBottom: "1px solid #dbe6f3",
    backgroundColor: "#f8fbff",
  },
  appBar: {
    backgroundColor: "#ffffff !important",
    color: "#1f2a44 !important",
    borderBottom: "1px solid #dbe6f3",
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.07)",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 16,
  },
  menuButtonHidden: {
    display: "none",
  },
  expand: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    backgroundColor: "#ffffff",
    color: "#324968",
    borderRight: "1px solid #dbe6f3",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
  },
  appBarSpacer: {
    height: headerHeight,
    minHeight: headerHeight,
    flexShrink: 0,
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2.5),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
    border: "1px solid #dbe6f3",
    borderRadius: 12,
    backgroundColor: "#ffffff",
  },
  fixedHeight: {
    height: 240,
  },
  submodules: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
  },
  submoduleLink: {
    fontWeight: 600,
    color: "#4b6488",
    textDecoration: "none",
    fontSize: 13,
    "&:hover": {
      color: "#2563eb",
    },
  },
  logo: {
    backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/logo.png"
      })`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "100%",
    height: "30px",
    margin: "10px",
  },
  inline: {
    display: "inline",
  },
  activeMenu: {
    color: "#1d4ed8 !important",
    textDecoration: "underline",
    textUnderlineOffset: 3,
    fontWeight: 700,
  },
  popover: {
    minWidth: 320,
    maxWidth: 420,
    maxHeight: 420,
    overflowY: "auto",
    padding: theme.spacing(1),
    border: "1px solid #dbe6f3",
    borderRadius: 10,
    backgroundColor: "#ffffff",
    boxShadow: "0 18px 34px rgba(15, 23, 42, 0.12)",
  },
}));
export default useStyles;
